export function u2000SessionHasOrganization(sessionOrganizationId: string | null | undefined): boolean {
  return (sessionOrganizationId ?? '').trim() !== '';
}

export function u2000CanManageSystemScopedEntity(
  hasRequiredRole: boolean,
  sessionOrganizationId: string | null | undefined,
): boolean {
  return hasRequiredRole && !u2000SessionHasOrganization(sessionOrganizationId);
}

export function u2000CanManageScopeAwareEntity(params: {
  isSystemScope: boolean;
  hasRequiredRole: boolean;
  sessionOrganizationId: string | null | undefined;
}): boolean {
  if (!params.hasRequiredRole) return false;
  if (!params.isSystemScope) return true;
  return u2000CanManageSystemScopedEntity(params.hasRequiredRole, params.sessionOrganizationId);
}

/** Config LLM org (provider/modèle/overrides) sur mission système — BL-0388 phase 2. */
export function u2000CanEditSystemMissionOrgConfig(params: {
  isSystemScope: boolean;
  hasEditRole: boolean;
  sessionOrganizationId: string | null | undefined;
}): boolean {
  return params.isSystemScope && params.hasEditRole && u2000SessionHasOrganization(params.sessionOrganizationId);
}

/** Prompts par défaut (copie org) — mission système : session avec organisation requise. */
export function u2000CanEditMissionDefaultPrompts(params: {
  isSystemScope: boolean;
  hasEditRole: boolean;
  sessionOrganizationId: string | null | undefined;
}): boolean {
  if (!params.hasEditRole) return false;
  if (!params.isSystemScope) return true;
  return u2000SessionHasOrganization(params.sessionOrganizationId);
}

/** Bouton Modifier U3203 : header global (admin sans org) ou config LLM org (mission système). */
export function u2000CanModifyU3203Mission(params: {
  isSystemScope: boolean;
  hasEditRole: boolean;
  sessionOrganizationId: string | null | undefined;
}): boolean {
  return (
    u2000CanManageScopeAwareEntity({
      isSystemScope: params.isSystemScope,
      hasRequiredRole: params.hasEditRole,
      sessionOrganizationId: params.sessionOrganizationId,
    }) ||
    u2000CanEditSystemMissionOrgConfig({
      isSystemScope: params.isSystemScope,
      hasEditRole: params.hasEditRole,
      sessionOrganizationId: params.sessionOrganizationId,
    })
  );
}
